module.exports = __webpack_public_path__ + "static/img/8.c4c58f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/8.png
// module id = IBij
// module chunks = 0